import { render } from "./IconFilterMobile.vue?vue&type=template&id=f54509a0"
import script from "./IconFilterMobile.vue?vue&type=script&lang=js"
export * from "./IconFilterMobile.vue?vue&type=script&lang=js"
script.render = render

export default script